import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import {
  GitlabClient,
  GitlabWebhookInstallRequest,
} from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useInstallGitlabWebhooksMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.install-webhooks');

  return useMutation({
    mutationKey: [MUTATION_KEYS.INSTALL_GITLAB_WEBHOOKS],
    mutationFn: (request: GitlabWebhookInstallRequest) =>
      GitlabClient.installWebhooks(request),
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
